export enum RiskRegisterGenerationStatus {
    NotGenerated = 0,
    Queued = 1,
    Running = 2,
    Completed = 3,
    Failed = 4,
}
